import moment from 'moment';
import { esimInfoENUM } from '../../../constants';
import fetchEsim from '../../../services/apollo/func/fetch/fetchEsim';
import fetchEsimHistories from '../../../services/apollo/func/fetch/fetchEsimHistories';
import handleDeleteEsim from '../../../services/apollo/func/handle/handleDeleteEsim';
import { formatPascalCase } from '../../../utils';
import auth from '../../../utils/auth';


export const formatValueByColumns = (column, data) => {
  // after all, this function should be refactored
  // because in this change request ESIM1-183
  // only have 2 column: status and license_id
  switch (column) {
    case esimInfoENUM.STATUS:
      return data === esimInfoENUM.ACTIVE || data === esimInfoENUM.INACTIVE || !data ? esimInfoENUM.UNBLOCKED : esimInfoENUM.BLOCKED;
    case esimInfoENUM.STORAGE1:
      return data === '-1' ? esimInfoENUM.UNLIMITED : data;
    case esimInfoENUM.STORAGE2:
      return data === '-1' ? esimInfoENUM.UNLIMITED : data;
    case esimInfoENUM.LICENSETYPE1:
      return formatPascalCase(data);
    case esimInfoENUM.LICENSETYPE2:
      return formatPascalCase(data);
    case esimInfoENUM.IS_ALLOWED_DUAL_ESIM:
      return data === 'true' ? esimInfoENUM.ALLOWED : esimInfoENUM.NOT_ALLOWED;
    case esimInfoENUM.DUALESIM2:
      return data ? esimInfoENUM.ALLOWED : esimInfoENUM.NOT_ALLOWED;
    case 'compatible_model':
      return data || '--';
    case 'compatible_brand':
      return data || '--';
    default:
      return '--';
  }
};

export const formatColumn = (column) => {
  if (column === esimInfoENUM.IS_ALLOWED_DUAL_ESIM) return esimInfoENUM.DUALESIM1;
  if (column === esimInfoENUM.STORAGE2) return esimInfoENUM.STORAGE3;
  if (column === esimInfoENUM.LICENSE_ID) return esimInfoENUM.LICENSE;
  if (column === 'compatible_model') return 'Model';
  if (column === 'compatible_brand') return 'Brand';
  return formatPascalCase(column);
};

export const formatLocalChangeLogs = data => data.map(audit => ({
  dateTime: audit?.dateTime ? moment(audit.dateTime).format('DD/MM/YYYY - HH:mm:ss') : '--',
  columns: formatColumn(audit?.column),
  oldValue: audit?.column === esimInfoENUM.LICENSE_ID ? audit?.licenseBefore?.name || '--' : formatValueByColumns(audit?.column, audit?.valueBefore),
  newValue: audit?.column === esimInfoENUM.LICENSE_ID ? audit?.licenseAfter?.name || '--' : formatValueByColumns(audit?.column, audit?.valueAfter),
  changeBy: `${auth.getLoginData()?.firstName} ${auth.getLoginData()?.lastName}`,
}));


export const formatChangeLogs = data => data.map(audit => ({
  key: audit.id,
  id: audit.id,
  dateTime: audit?.createdAt ? moment(audit.createdAt).format('DD/MM/YYYY - HH:mm:ss') : '--',
  columns: formatColumn(audit?.column),
  oldValue: audit?.column === esimInfoENUM.LICENSE_ID ? audit?.licenseBefore?.name || '--' : formatValueByColumns(audit?.column, audit?.valueBefore),
  newValue: audit?.column === esimInfoENUM.LICENSE_ID ? audit?.licenseAfter?.name || '--' : formatValueByColumns(audit?.column, audit?.valueAfter),
  changeBy: audit?.actionBy ? `${audit?.actionBy?.firstName || '-'} ${audit?.actionBy?.lastName || '-'}` : '--',
}));

export const getChangeLogColumns = () => {
  const columns = [
    {
      title: 'Date',
      dataIndex: 'dateTime',
      key: 'dateTime',
    },
    {
      title: 'Object',
      dataIndex: 'columns',
      key: 'columns',
    },
    {
      title: 'Old value',
      dataIndex: 'oldValue',
      key: 'oldValue',
    },
    {
      title: 'New value',
      dataIndex: 'newValue',
      key: 'newValue',
    },
    {
      title: 'Change by',
      dataIndex: 'changeBy',
      key: 'changeBy',
    },
  ];
  return columns;
};

export const formatCardInformation = (cardInfo) => {
  const data = [
    {
      title: 'CARD\'S INFORMATION',
      data: [
        {
          label: 'eID:',
          value: cardInfo.id,
          link: '',
        },
        {
          label: 'Status:',
          value: (cardInfo?.status === esimInfoENUM.ACTIVE || cardInfo?.status === esimInfoENUM.INACTIVE) ? esimInfoENUM.UNBLOCKED : esimInfoENUM.BLOCKED,
          link: '',
        },
        {
          label: 'eStorage:',
          value: !cardInfo?.license ? '--' : cardInfo?.license?.storage === -1 ? 'Unlimited' : cardInfo?.license?.storage,
          link: '',
        },
        {
          label: 'License type:',
          value: cardInfo?.license?.licenseType ? formatPascalCase(cardInfo.license?.licenseType) : '--',
          link: '',
        },
        {
          label: 'Dual-eSIM:',
          value: cardInfo?.license?.isAllowedDual ? esimInfoENUM.ALLOWED : esimInfoENUM.NOT_ALLOWED,
          link: '',
        },
        {
          label: 'Compatible brand:',
          value: cardInfo?.compatibleBrand ? cardInfo.compatibleBrand : '--',
          link: '',
        },
        {
          label: 'Compatible model:',
          value: cardInfo?.compatibleModel ? cardInfo.compatibleModel : '--',
          link: '',
        },
        {
          label: 'Created on:',
          value: cardInfo?.createdAt ? moment(cardInfo?.createdAt).format('DD/MM/YYYY - HH:mm:ss') : '--',
          link: '',
        },
        {
          label: 'Created by:',
          value: cardInfo?.createdBy ? `${cardInfo?.createdBy?.firstName || '-'} ${cardInfo?.createdBy?.lastName || '-'}` : '--',
          link: '',
        },
      ],
    },
  ];
  return { info: data, license: cardInfo.license };
};

export const handleFetchEsimInfor = async (esimId) => {
  try {
    const esim = await fetchEsim({ esimId }, 0);
    return formatCardInformation(esim);
  } catch (error) {
    return {};
  }
};

export const handleFetchEsimHistories = async (filter, limit) => {
  try {
    const esimHistories = await fetchEsimHistories({ filter, limit });
    return formatChangeLogs(esimHistories);
  } catch (error) {
    return [];
  }
};

export const deleteCard = async (esimId) => {
  try {
    const deletedEsim = await handleDeleteEsim({ esimId });
    return deletedEsim;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};
